"use client"

import { memo } from "react"

import { cn } from "@productlane/lib/src/browser"

export interface LanguageTagProps {
	code: string
	className?: string
}

export const LanguageTag = memo(function LanguageTag({
	code,
	className,
}: LanguageTagProps) {
	return (
		<span
			className={cn(
				"mx-px inline-flex items-center justify-center rounded bg-green-100 px-1.5 py-0.5 text-[0.7rem] font-semibold uppercase text-green-700 ring-1 ring-inset ring-green-500/40 dark:bg-green-500/20 dark:text-green-400 dark:ring-green-500/30",
				className,
			)}
		>
			{code.toUpperCase()}
		</span>
	)
})
